import OurMissionImg from "../../shared/assets/images/ourMission.png";
import Title from "../../shared/ui/Title/Title";
import ParagraphSection from "../../shared/ui/ParagraphSection/ParagraphSection";
import cls from "./Mission.module.css";
import MarginBottomContainer from "../../shared/ui/MarginBottomContainer/MarginBottomContainer";
const OurMission = () => {
    return (
        <div id="mission" className="mission-section">
            <div className="container container--main">
                <div className={cls.missionWrapper}>
                    <div className="mission-wrapper__header">
                        <MarginBottomContainer margin={22}>
                            <Title title="Our mission" />
                        </MarginBottomContainer>
                    </div>
                    <MarginBottomContainer margin={90}>
                        <div className={cls.missionWrapperInfo}>
                            <ParagraphSection>
                                Our goal is to fuel scalable growth for our partners by running performance-based campaigns that deliver real conversions. We prioritize ROI, transparency, and flexibility, tailoring solutions to each traffic source and product. Whether you’re an e-commerce business, mobile app developer, or a global brand, we help you acquire valuable users that make an impact.
                            </ParagraphSection>
                        </div>
                    </MarginBottomContainer>

                    <div className="mission-wrapper__image">
                        <img className="img" src={OurMissionImg} alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OurMission;
